import { match } from 'ts-pattern'

import { APP_NAME } from '#@/platform/env/constants/app'
import { env } from '#@/platform/lib/env/endpoints'
import type { ServiceType } from '#@/platform/networking/types/serviceType'

// Sentinel origin for marketplace-api. These apps never reach MAPI through a public hostname. Server-side calls use
// the Cloudflare `MAPI` service binding, and browser-side calls use the `/auth/proxy/mapi/*` route. The value does
// not identify an environment. It provides the prefix that the networking layer uses to select the binding.
export const MAPI_SENTINEL_URL = 'https://_sentinel___bound_via_cloudflare_'

export function getEndpointUrl(service: ServiceType) {
  const endpoint = match(service)
    .with('graph', () => env.NEXT_PUBLIC_DISTRICT_GRAPH_URL)
    .with('django', () => env.NEXT_PUBLIC_DISTRICT_DJANGO_URL)
    .with('mapi', () => MAPI_SENTINEL_URL)
    .with('aapi', () => env.NEXT_PUBLIC_DISTRICT_ADMIN_API_URL)
    .with('shiphero', () => env.NEXT_PUBLIC_DISTRICT_SHIPHERO_API_URL)
    .with('agents', () => env.NEXT_PUBLIC_DISTRICT_AGENTS_API_URL)
    .exhaustive()

  if (!endpoint) {
    throw new Error(`${service} is not configured for ${APP_NAME}`)
  }
  return endpoint
}
